import Enums from '@core/types/api/Enums';
import type { PrimaryProductCategory } from '@core/utils/productCategoryFilter';
import type { NestedKeyOf } from '@core/utils/types';

import type { FilterByOpts } from './ApiClient';

export const withProductCategoryFilter = <
  T extends { productCategory?: Enums.ProductCategory | null },
>(
  filters: FilterByOpts<T>[],
  singleProductCategory: Enums.ProductCategory | undefined,
): FilterByOpts<T>[] => {
  if (
    singleProductCategory === undefined ||
    filters.some(
      (f) =>
        'name' in f &&
        f.name === 'productCategory' &&
        'operation' in f &&
        f.operation === Enums.FilterOperation.Equals,
    )
  ) {
    return filters;
  }
  return [
    ...filters,
    {
      name: 'productCategory' as NestedKeyOf<T>,
      operation: Enums.FilterOperation.Equals,
      values: [singleProductCategory],
    },
  ];
};

export const productCategoryFilter = <T extends {}>(
  productCategory: PrimaryProductCategory | null,
): FilterByOpts<T> => ({
  name: 'productCategory' as any,
  operation: Enums.FilterOperation.Equals,
  values: productCategory !== null ? [productCategory] : [],
});
